<template>
  <div class="claim">
    <!-- “claim”限制css于本页面 -->
    <!-- 搜索 -->
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @companyChange="companyChange"
      @payerChange="payerChange"
      @bankBranchChange="bankBranchChange"
      @ladingNoChange="ladingNoChange"
      @salesNoChange="salesNoChange"
      @purchaseNoChange="purchaseNoChange"
      @receivedTypeChange="receivedTypeChange"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @sortChangeEvent="sortChangeEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @toggleMethod="toggleMethod"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field === 'businessType'">
              {{ businessTypeList.find((item) => item.value == scope.row['businessType'])?.label }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
          <template v-slot:content="{ row }">
            <div class="claim-tabs-box">
              <el-tabs type="border-card" v-model="tabActiveNames">
                <!-- 一次认领 -->
                <el-tab-pane
                  :label="$t('receivablesManage.tabTitle.firstClaimsTitle')"
                  name="first"
                >
                  <vxe-table
                    border
                    show-overflow
                    resizable
                    ref="firstClaim"
                    class="vxe-table-element"
                    size="mini"
                    align="left"
                    min-width="120"
                    :auto-resize="true"
                    :data="row.fundCollectionFirstClaimList ? row.fundCollectionFirstClaimList : []"
                    max-height="200px"
                  >
                    <vxe-table-column
                      type="seq"
                      width="50"
                      :title="$t('receivablesManage.receivablesClaimInfo.seq')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="customerName"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.customerNo')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="claimPartnerName"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.claimPartnerNo')"
                    ></vxe-table-column>
                    <vxe-table-column field="receivedType" width="150" title="收款类别">
                      <template v-slot="{ row }">{{
                        getReceivedType(row.receivedType, row.businessType)
                      }}</template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="claimDepartmentName"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.claimDepartmentNo')"
                    ></vxe-table-column>
                    <!-- <vxe-table-column
                      field="settleBatchNo"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.settleBatchNo')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="originProformaInvoiceAmount"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.originProformaInvoiceAmount')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localProformaInvoiceAmount"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.localProformaInvoiceAmount')
                      "
                    ></vxe-table-column> -->
                    <vxe-table-column field="originReceiveMoneyAmount" width="150" title="收款金额">
                      <template slot-scope="scope">
                        <span>
                          {{ replaceZeroStr(scope.row['originReceiveMoneyAmount']) }}
                        </span>
                      </template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="localReceiveMoneyAmount"
                      width="150"
                      title="收款金额（本币）"
                    >
                      <template slot-scope="scope">
                        <span>
                          {{ replaceZeroStr(scope.row['localReceiveMoneyAmount']) }}
                        </span>
                      </template>
                    </vxe-table-column>
                    <!-- <vxe-table-column
                      field="originDomesticBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.originDomesticBankDeductFee')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localDomesticBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.localDomesticBankDeductFee')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="originForeignBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.originForeignBankDeductFee')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localForeignBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.localForeignBankDeductFee')
                      "
                    ></vxe-table-column> -->
                  </vxe-table>
                </el-tab-pane>
                <!-- 二次认领 -->
                <el-tab-pane
                  :label="$t('receivablesManage.tabTitle.secondClaimsTitle')"
                  name="second"
                >
                  <vxe-table
                    border
                    show-overflow
                    resizable
                    ref="secondClaim"
                    class="vxe-table-element"
                    size="mini"
                    align="left"
                    min-width="120"
                    :auto-resize="true"
                    :data="
                      row.fundCollectionSecondClaimList ? row.fundCollectionSecondClaimList : []
                    "
                    max-height="200px"
                  >
                    <vxe-table-column
                      type="seq"
                      width="50"
                      :title="$t('receivablesManage.receivablesClaimInfo.seq')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="customerName"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.customerNo')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="claimDepartmentName"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.claimDepartmentNo')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="receivedType"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.receivedType')"
                    >
                      <template v-slot="{ row }">{{
                        getReceivedType(row.receivedType, row.businessType)
                      }}</template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="receivedDetailType"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.receivedDetailType')"
                    >
                      <template v-slot="{ row }">{{
                        getSelectLabel(row.receivedDetailType, receivedDetailTypeList)
                      }}</template>
                    </vxe-table-column>
                    <vxe-table-column
                      field="projectCode"
                      width="150"
                      title="项目编号"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="settlementNo"
                      width="150"
                      title="结算单"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="salesOrderNo"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.salesOrderNo')"
                    ></vxe-table-column>
                    <!-- <vxe-table-column
                      field="ladingNo"
                      width="150"
                      :title="'提单号'"
                    ></vxe-table-column> -->
                    <vxe-table-column
                      field="purchaseOrderNo"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.purchaseOrderNo')"
                    ></vxe-table-column>
                    <!-- <vxe-table-column
                      field="contractNo"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.contractNo')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="originProformaInvoiceAmount"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.originProformaInvoiceAmount')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localProformaInvoiceAmount"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.localProformaInvoiceAmount')
                      "
                    ></vxe-table-column> -->
                    <vxe-table-column
                      field="originReceiveMoneyAmount"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.originReceiveMoneyAmount')"
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localReceiveMoneyAmount"
                      width="150"
                      :title="$t('receivablesManage.receivablesClaimInfo.localReceiveMoneyAmount')"
                    ></vxe-table-column>
                    <!-- <vxe-table-column
                      field="originDomesticBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.originDomesticBankDeductFee')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localDomesticBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.localDomesticBankDeductFee')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="originForeignBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.originForeignBankDeductFee')
                      "
                    ></vxe-table-column>
                    <vxe-table-column
                      field="localForeignBankDeductFee"
                      width="150"
                      :title="
                        $t('receivablesManage.receivablesClaimInfo.localForeignBankDeductFee')
                      "
                    ></vxe-table-column> -->
                  </vxe-table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <sirui-upload @getNoCheckData="getNoCheckData" ref="siruiUpload"></sirui-upload>
    <!-- 批量认领 -->
    <batch-first-claim-dialog
      @getNoCheckData="getNoCheckData"
      ref="batchFirstClaimDialog"
    ></batch-first-claim-dialog>
  </div>
</template>
<script>
  import API from '@/api/capitalCenter/receivablesManage';
  import tableMixins from '@/common/mixins/table.js';
  import dataBaseAPI from '@/api/dataBase';
  import siruiUpload from '@/components/SiruiUpload';
  import batchFirstClaimDialog from './components/batchFirstClaimDialog';
  import { toLine } from '@/common/js/util';
  import XEUtils from 'xe-utils';
  // import qs from 'qs';
  export default {
    name: 'claimManageCK',
    mixins: [tableMixins],
    components: {
      siruiUpload,
      batchFirstClaimDialog,
    },
    computed: {
      receivedTypeList() {
        let list =
          [
            ...this.dictListMap.parkReceivedType,
            ...this.dictListMap.multimodalTransportReceivedType,
            ...this.dictListMap.receivedType,
            ...this.dictListMap.property_settlement_cost,
          ] || [];
        var obj = {};
        var result = [];
        for (let i = 0; i < list.length; i++) {
          if (!obj[list[i].value]) {
            result.push(list[i]);
            obj[list[i].value] = true;
          }
        }
        return result;
      },
      receivedTypeMap() {
        return {
          '01': this.dictListMap.receivedType,
          '02': this.dictListMap.multimodalTransportReceivedType,
          '03': this.dictListMap.warehouseContractGuizhongLoadExpenseList,
          '04': this.dictListMap.property_settlement_cost,
          '05': this.dictListMap.parkReceivedType,
          '06': this.dictListMap.receivedType,
        };
      },
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 公司代码
            name: this.$t('receivablesManageList.registerColumn.registerCompanyCode'),
            prop: 'registerCompanyCode',
            type: 'select',
            options: this.companyList,
            changeMethod: 'companyChange',
            filterable: true,
          },
          {
            // 收款登记号
            name: this.$t('receivablesManageList.claimColumn.registerNo'),
            prop: 'registerNo',
            type: 'input',
          },
          {
            // 收款状态
            name: this.$t('receivablesManageList.claimColumn.receiveStatus'),
            prop: 'receiveStatus',
            type: 'dict',
            dictType: 'receiveClaimStatus',
          },
          {
            // 收款类别
            type: 'selectDouble',
            prop: ['businessType', 'receivedTypes'],
            name: '收款类别',
            options1: this.businessTypeList,
            options2: this.receivedList,
            changeMethod: 'receivedTypeChange',
            isMultiple: [false, true],
          },
          {
            // 未一次认领金额
            type: 'selectInput',
            prop: ['firstJudgeFlag', 'firstUnClaimAmount'],
            name: this.$t('receivablesManageList.claimColumn.firstUnClaimAmount'),
            options: [
              { value: 1, label: '大于' },
              { value: 2, label: '小于' },
              { value: 3, label: '不等于' },
              { value: 4, label: '等于' },
            ],
          },
          {
            // 未二次认领金额
            type: 'selectInput',
            prop: ['secondJudgeFlag', 'secondUnClaimAmount'],
            name: this.$t('receivablesManageList.claimColumn.secondUnClaimAmount'),
            options: [
              { value: 1, label: '大于' },
              { value: 2, label: '小于' },
              { value: 3, label: '不等于' },
              { value: 4, label: '等于' },
            ],
          },
          {
            // 预认领部门
            name: this.$t('receivablesManageList.claimColumn.preclaimDepartmentCode'),
            prop: 'preclaimDepartmentCode',
            type: 'treeSelect',
            apiUrl: dataBaseAPI.LIST_COMPANY_DEPT_TREE,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            multiple: true,
          },
          {
            // 收款日期从
            name: this.$t('receivablesManageList.search.registerStartDate'),
            prop: 'registerStartDate',
            type: 'startDaterangePicker',
          },
          {
            // 收款日期到
            name: this.$t('receivablesManageList.search.registerEndDate'),
            prop: 'registerEndDate',
            type: 'endDaterangePicker',
          },
          {
            // 收款金额
            type: 'inputRange',
            prop: ['originReceiveMoneyMinAmount', 'originReceiveMoneyMaxAmount'],
            precision: 2, //精度，就是保留几位小数,默认两位
            max: 99999999999999.99,
            name: this.$t('receivablesManageList.claimColumn.originReceiveMoneyAmount'),
            span: 12,
          },
          {
            // 付款单位
            type: 'searchTableSpec',
            prop: 'payerCode',
            name: this.$t('receivablesManageList.registerColumn.payerName'),
            searchType: 'partner',
            isMultiple: true,
            extraData: {
              companyCode: this.query.registerCompanyCode,
              partnerTypes: 'HZHB01,HZHB02,HZHB03', // 客户、供应商、合作伙伴
            },
            changeMethod: 'payerChange',
            currentValue: this.query.payerName,
          },
          {
            // 认领部门
            name: '认领部门',
            prop: 'claimDepartmentNos',
            type: 'treeSelect',
            apiUrl: dataBaseAPI.LIST_COMPANY_DEPT_TREE,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            ref: 'claimDepartmentNosRef',
            multiple: true,
          },
          {
            // 是否代付
            name: this.$t('receivablesManageList.claimColumn.isAnotherPay'),
            prop: 'isAnotherPay',
            type: 'dict',
            dictType: 'isAnotherPay',
          },
          /* {
          // 代付时间从
          name: this.$t('receivablesManageList.search.anotherPayStartTime'),
          prop: 'anotherPayStartTime',
          type: 'startDaterangePicker',
        },
        {
          // 代付时间到
          name: this.$t('receivablesManageList.search.anotherPayEndTime'),
          prop: 'anotherPayEndTime',
          type: 'endDaterangePicker',
        },
        {
          // 是否财务通过
          name: this.$t('receivablesManageList.claimColumn.financeAuditStatus'),
          prop: 'financeAuditStatus',
          type: 'dict',
          dictType: 'financeAuditStatusForRecieve',
        }, */
          {
            // 币种
            type: 'dict',
            prop: 'receiveInfoCurrencyCode',
            name: this.$t('paymentList.table.currencyCode'),
            dictType: 'all_currency',
          },
          {
            // 收款银行
            type: 'searchTableSpec',
            prop: 'receiveBankNo',
            name: this.$t('receivablesManage.basicInfo.receiveBankNo'),
            searchType: 'bankAccountBranchName',
            extraData: {
              bankAccountStatus: '001',
              companyCode: this.query.registerCompanyCode,
            },
            isMultiple: true,
            changeMethod: 'bankBranchChange',
          },
          {
            // 收款银行账号
            type: 'input',
            prop: 'receiveBankAccount',
            name: this.$t('receivablesManage.basicInfo.receiveBankAccount'),
            disabled: true,
          },
          /* {
          //提单号
          prop: 'secondClaimLadingNoList',
          name: '提单号',
          type: 'searchTableSpec',
          searchType: 'salesLading',
          isMultiple: false,
          placeholder: '请选择提单号',
          changeMethod: 'ladingNoChange',
        }, */
          // {
          //   //销售合同号
          //   prop: 'secondClaimSalesOrderNoList',
          //   name: '销售合同号',
          //   type: 'searchTableSpec',
          //   searchType: 'contract',
          //   extraData: { contractCategory: 'sales', contractStatus: 'ZT03' },
          //   isMultiple: false,
          //   placeholder: '请选择销售合同号',
          //   changeMethod: 'salesNoChange',
          // },
          // {
          //   //采购合同号
          //   prop: 'secondClaimPurchaseOrderNoList',
          //   name: '采购合同号',
          //   type: 'searchTableSpec',
          //   searchType: 'contract',
          //   extraData: { contractCategory: 'purchase', contractStatus: 'ZT03' },
          //   isMultiple: false,
          //   placeholder: '请选择采购合同号',
          //   changeMethod: 'purchaseNoChange',
          // },
        ];
      },
    },
    data() {
      return {
        footerTotalCols: {
          amount: [
            'firstClaimAmount',
            'secondClaimAmount',
            'firstUnClaimAmount',
            'secondUnClaimAmount',
            'originProformaInvoiceAmount',
            'originReceiveMoneyAmount',
            'originDomesticBankDeductFee',
            'originForeignBankDeductFee',
          ],
        }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        exportAction: API.EXPORT_COLLECTIONCLAIM,
        tabActiveNames: 'first',
        query: {
          registerCompanyCode: null, // 公司代码
          registerNo: null, // 收款登记号
          receiveStatus: null,
          amountType: 1,
          firstJudgeFlag: null,
          secondJudgeFlag: null,
          firstUnClaimAmount: null, // 未一次认领金额
          secondUnClaimAmount: null, // 未二次认领金额
          originReceiveMoneyMinAmount: null, // 收款金额
          originReceiveMoneyMaxAmount: null,
          registerStartDate: null,
          registerEndDate: null,
          preclaimDepartmentCode: null,
          claimDepartmentNos: null,
          payerCode: null, // 付款单位
          payerName: null,
          existVoucher: null,
          isAnotherPay: null, // 是否代付
          anotherPayStartTime: null, // 代付时间从
          anotherPayEndTime: null, // 代付时间到
          financeAuditStatus: null, // 是否财务审核通过
          receiveBankNo: null, //收款银行
          receiveBankName: null,
          receiveBankAccount: null,
          secondClaimLadingNoList: null, // 提单号
          secondClaimSalesOrderNoList: null, // 销售合同号
          secondClaimPurchaseOrderNoList: null, // 采购合同号
          businessType: null, //业务类别
          receivedTypes: null, //收款类别
        },
        sortParams: '',
        columnListDefault: [
          {
            // 复选框
            type: 'checkbox',
            width: '50',
            fixed: 'left',
          },
          {
            // 切换
            type: 'expand',
            width: '50',
            fixed: 'left',
          },
          {
            // 收款登记号
            field: 'registerNo',
            title: 'receivablesManageList.claimColumn.registerNo',
            width: '180',
            sortable: true,
          },
          {
            // 付款单位
            field: 'payerName',
            title: 'receivablesManageList.claimColumn.payerName',
          },
          {
            // 是否代付(新增)
            field: 'isAnotherPay',
            title: 'receivablesManageList.claimColumn.isAnotherPay',
            dictType: 'isAnotherPay',
          },
          {
            // 付款银行(新增)
            field: 'payBankName',
            title: 'receivablesManageList.claimColumn.payBankName',
          },
          {
            // 付款银行账号
            field: 'payBankAccount',
            title: 'receivablesManageList.claimColumn.payBankAccount',
          },
          {
            // 银行流水号
            field: 'bankFlowNo',
            title: 'receivablesManageList.claimColumn.bankFlowNo',
          },
          /* {
          // 收款单制单日期(新增)
          field: 'voucherCreateDate',
          title: 'receivablesManageList.claimColumn.voucherCreateDate',
        },
        {
          // 收款登记摘要(新增)
          field: 'summary',
          title: 'receivablesManageList.claimColumn.summary',
        }, */
          {
            // 币种
            field: 'receiveInfoCurrencyName',
            title: 'receivablesManageList.registerColumn.receiveInfoCurrencyCode',
          },
          {
            // 一次认领总金额
            field: 'firstClaimAmount',
            title: 'receivablesManageList.claimColumn.firstClaimAmount',
            format: 'formatAmount',
          },
          {
            // 二次认领总金额
            field: 'secondClaimAmount',
            title: 'receivablesManageList.claimColumn.secondClaimAmount',
            format: 'formatAmount',
          },
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title: 'receivablesManageList.claimColumn.originReceiveMoneyAmount',
            format: 'formatAmount',
            sortable: true,
          },
          {
            //摘要
            field: 'summary',
            title: 'receivablesManageList.claimColumn.summary',
          },
          {
            // 收款状态
            field: 'receiveStatus',
            title: 'receivablesManageList.claimColumn.receiveStatus',
            dictType: 'receiveClaimStatus',
          },
          {
            field: 'businessType',
            title: '业务类别',
            visible: true,
            width: 120,
          },
          {
            // 公司代码
            field: 'registerCompanyCode',
            title: 'receivablesManageList.claimColumn.registerCompanyCode',
          },
          {
            // 收款日期
            field: 'registerDate',
            title: 'receivablesManageList.claimColumn.registerDate',
            sortable: true,
          },
          {
            // 制单人
            field: 'registerCreatePersonName',
            title: 'receivablesManageList.claimColumn.registerCreatePersonName',
            sortable: true,
          },
          {
            // 收款方式
            field: 'receiveMethod',
            title: 'receivablesManageList.claimColumn.receiveMethod',
            sortable: true,
            dictType: 'receiveMethod',
          },
          {
            // 来源
            field: 'receiveResource',
            title: 'receivablesManageList.claimColumn.receiveResource',
            sortable: true,
            dictType: 'receiveResource',
          },
          {
            // 收款银行(新增)
            field: 'receiveBankName',
            title: 'receivablesManageList.claimColumn.receiveBankName',
          },
          {
            // 收款银行账号
            field: 'receiveBankAccount',
            title: 'receivablesManageList.claimColumn.receiveBankAccount',
          },
          /* {
          // 代付时间(新增)
          field: 'anotherPayTime',
          title: 'receivablesManageList.claimColumn.anotherPayTime',
          sortable: true,
        },
        {
          // 是否财务审核通过(新增)
          field: 'financeAuditStatus',
          title: 'receivablesManageList.claimColumn.financeAuditStatus',
          dictType: 'financeAuditStatusForRecieve',
        }, */
          /* {
          // 未一次认领金额
          field: 'firstUnClaimAmount',
          title: 'receivablesManageList.claimColumn.firstUnClaimAmount',
          format: 'formatAmount',
        },
        {
          // 未二次认领金额
          field: 'secondUnClaimAmount',
          title: 'receivablesManageList.claimColumn.secondUnClaimAmount',
          format: 'formatAmount',
        },
        {
          // 形式发票金额
          field: 'originProformaInvoiceAmount',
          title: 'receivablesManageList.claimColumn.originProformaInvoiceAmount',
          format: 'formatAmount',
          sortable: true,
        }, */
          /* {
          // 国内银行扣费
          field: 'originDomesticBankDeductFee',
          title: 'receivablesManageList.claimColumn.originDomesticBankDeductFee',
          format: 'formatAmount',
          sortable: true,
        },
        {
          // 国外银行扣费
          field: 'originForeignBankDeductFee',
          title: 'receivablesManageList.claimColumn.originForeignBankDeductFee',
          format: 'formatAmount',
          sortable: true,
        },
        {
          // 录入日期
          field: 'gmtCreate',
          title: '录入日期',
          visible: true,
          width: 120,
          sortable: true,
        }, */
        ],
        companyList: [],
        // receivedTypeList: [], //this.$baseRequest.getDictListMapByType('receivedType'), //款项类型列表
        receivedDetailTypeList: this.$baseRequest.getDictListMapByType('receivedDetailType'), //款项类型列表
        // 业务列别
        businessTypeList: [
          { label: '贸易', value: '01' },
          { label: '多式联运', value: '02' },
          { label: '园区仓储', value: '03' },
          { label: '园区物业', value: '04' },
          { label: '监管单', value: '05' },
          { label: '城矿', value: '06' },
        ],
        // 收款类别
        receivedList: [],
      };
    },
    mounted() {
      this.getData();
      this.getCompany();
      this.getButtonList();
    },
    methods: {
      resetBtnClick() {
        this.query = { receivedTypes: null };
        this.query.claimDepartmentNos = '';

        this.$refs.siruiSearch.$refs.claimDepartmentNosRef &&
          this.$refs.siruiSearch.$refs.claimDepartmentNosRef[0] &&
          this.$refs.siruiSearch.$refs.claimDepartmentNosRef[0]?.resetClick();
        this.getData();
      },
      //表格回显方法
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      getReceivedType(value, businessType) {
        let item = XEUtils.find(
          this.receivedTypeMap[businessType],
          (item) => item['value'] === value
        );
        return item ? item['label'] : null;
      },
      // 根绝业务类别区分收款类别（搜索）
      receivedTypeChange(val) {
        console.log('变更业务类别', val);
        if (val.prop == 'businessType') {
          this.query.receivedTypes = null;
          this.receivedList = this.receivedTypeMap[val.val] || [];
        }
        // if(val.prop=='receivedTypes'){
        //   this.query.receivedTypes= val.val
        // }
      },
      // 获取列表数据
      async getData() {
        let params = this.setSearchParams();
        params.orderByDesc = this.sortParams;
        // if (!params.registerCompanyCode) {
        //   params.registerCompanyCode = this.userInfo.userInfo.companyCode;
        // }
        this.load = true;
        let res = await this.$axios.post(API.QUERY_COLLECTIONCLAIM_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      setSearchParams() {
        const { pageSize, pageNum } = this.$refs.siruiTable.page;
        let params = { ...this.query, pageSize, pageNum };
        params.claimDepartmentNos = params.claimDepartmentNos
          ? params.claimDepartmentNos.split(',')
          : null;
        return params;
      },
      //排序
      sortChangeEvent({ property, order }) {
        if (order) {
          this.sortParams = `tfcr.${toLine(property)} ${order}`;
        } else {
          this.sortParams = '';
        }
        this.getData();
      },
      bankBranchChange(val) {
        console.log(11);
        val = val.val;
        if (val && val.length > 0 && val[0].branchName) {
          this.query.receiveBankName = val[0].branchName;
          this.query.receiveBankNo = val[0].branchCode;
          this.query.receiveBankAccount = val[0].bankAccountNum;
        } else {
          this.query.receiveBankName = null;
          this.query.receiveBankNo = null;
          this.query.receiveBankAccount = null;
        }
      },
      ladingNoChange(val) {
        console.log(val);
        val = val.val;
        if (val && val.length > 0) {
          this.query.secondClaimLadingNoList = val.map((it) => it.ladingNo);
        } else {
          this.query.secondClaimLadingNoList = null;
        }
      },
      salesNoChange(val) {
        console.log(val);
        val = val.val;
        if (val && val.length > 0) {
          this.query.secondClaimSalesOrderNoList = val.map((it) => it.contractNo);
        } else {
          this.query.secondClaimSalesOrderNoList = null;
        }
      },
      purchaseNoChange(val) {
        console.log(val);
        val = val.val;
        if (val && val.length > 0) {
          this.query.secondClaimPurchaseOrderNoList = val.map((it) => it.contractNo);
        } else {
          this.query.secondClaimPurchaseOrderNoList = null;
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(dataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      async pushGoldie() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelectData', 'warning');
        }
        const ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        // 推送金蝶
        let params = {
          ids,
        };
        const res = await this.$axios.post(API.TRANSACTION_WRITE_CLAIM, {
          ...params,
          businessGroup: this.userInfo.businessGroup,
        });
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            type: 'success',
            message: res.data.msg,
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: res.data.msg,
          });
        }
      },
      companyChange() {
        // 切换公司
        this.query.payerCode = this.query.payerName = null;
      },
      payerChange(val) {
        // 付款单位
        let item = val.val;
        if (item && item.length > 0) {
          this.query.payerCode = item[0].partnerCode;
          this.query.payerName = item[0].partnerZhName;
        } else {
          this.query.payerCode = this.query.payerName = null;
        }
      },
      toggleMethod() {
        this.tabActiveNames = 'first';
      },
      // 按钮
      chooseClick(type) {
        console.log(type, '1111');
        if (type == 'batchFirstClaim') {
          // 批量一次认领
          this.batchFirstClaim();
        } else if (type == 'claim') {
          // 认领
          this.handleClaim();
        } else if (type == 'export') {
          //导出
          this.handleExport();
        } else if (type === 'batchCreate') {
          // 生成收款单
          this.handleCreateOrder();
        } else if (type === 'pushGoldie') {
          // 推送金蝶
          this.pushGoldie();
        }
      },
      // 认领
      async handleClaim() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelectData', 'warning');
        }
        if (this.multipleSelection.length > 1) {
          return this.tips('onlyOneSelectData', 'warning');
        }
        const businessType = this.multipleSelection.map((item) => item.businessType);
        const ids = this.multipleSelection.map((item) => {
          return item.id;
        });

        //做认领前先校验有没有部门权限
        this.load = true;
        let params = {
          ids,
        };
        let res = await this.$axios.post(API.GET_CLAIMINFO_CHECK, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.toPath('claimCK', { ids: JSON.stringify(ids), businessType: businessType[0] });
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      // 批量一次认领
      batchFirstClaim() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelectData', 'warning');
        }
        // 检查公司是否存在非待认领状态
        if (
          this.multipleSelection.some((item) => {
            return item.receiveStatus != '01';
          })
        ) {
          return this.tips('noRegister', 'warning');
        }
        // 检查公司是否一致
        if (
          this.multipleSelection.some((item) => {
            return item.registerCompanyCode != this.multipleSelection[0].registerCompanyCode;
          })
        ) {
          return this.$message({
            showClose: true,
            message: '请选择同一公司下的单据进行批量一次认领！',
            type: 'warning',
          });
        }
        const ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        // 检查是否付款单位一致
        let flag = this.multipleSelection.some((item) => {
          return item.payerCode != this.multipleSelection[0].payerCode;
        });
        if (flag) {
          return this.$message({
            showClose: true,
            message: '请选择同一付款单位下的单据进行批量一次认领！',
            type: 'warning',
          });
        }
        console.log(this.multipleSelection, '111??1');
        let selVal = {
          registerCompanyCode: this.multipleSelection[0].registerCompanyCode,
          businessType: this.multipleSelection[0].businessType, // 类型
          payerCode: flag ? null : this.multipleSelection[0].payerCode, // 付款单位
          payerName: flag ? null : this.multipleSelection[0].payerName, // 付款单位名称
          payerType: flag ? null : this.multipleSelection[0].payerType, // 付款单位类型
        };
        this.$refs.batchFirstClaimDialog.openDialog(true, ids, selVal);
      },
      // 生成收款单
      handleCreateOrder() {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelectData', 'warning');
        }
        if (
          this.multipleSelection.some((item) => {
            return (
              item.receiveStatus != '03' ||
              ((item.isAnotherPay == 'Y' || item.isAnotherPay == true) &&
                item.financeAuditStatus != '002')
            );
          })
        ) {
          return this.tips('noClaimed', 'warning');
        }
        this.$confirmAction(this.$t('receivablesManageList.message.createOrder'), '')
          .then(() => {
            this.createOrder();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('cooperation.message.cancelled'),
            });
          });
      },
      async createOrder() {
        this.loading.startLoading();
        let params = this.multipleSelection.map((item) => {
          return item.id;
        });
        let res = await this.$axios.post(API.CREATE_COLLECTIONCLAIM_ORDER, params);
        this.loading.endLoading();
        if (res) {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.getNoCheckData();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        }
      },
      handleExport() {
        if (this.tableData.length == 0) {
          return this.$message({
            showClose: true,
            message: this.$t('message.noExport'),
            type: 'warning',
          });
        }
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          changeList.forEach((item) => {
            str += 'exportIds=' + item.id + '&';
          });
          window.location.href = `${this.baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
        } else {
          let params = this.setSearchParams();
          //默认
          params.orderByDesc = this.sortParams;
          params = XEUtils.serialize(params);
          params = params.replaceAll('%5B%5D', '');
          window.location.href = `${this.baseUrl}${this.exportAction}?${params}&access_token=${this.token.access_token}`;
        }
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManageList.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/capital/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .claim-tabs-box {
    padding-left: 90px;
  }
</style>
